




























# import settings from '@/settings'
import t from '@/utils/tools'
import Menus from '@/components/menus'

export default {
    name: 'users_abs_tel'

    components: { Menus }

    watch:
        '$route': (route_to, route_from)->
            # console.log "WATCH ROUTE", route_to,
            if route_to.name == 'users_abs_tel'
                @define_route()

    data: ()->
        head_title: ''
        # absences_accesses: ['absences_self_edit','telework_self_edit','oncall_duties_self_show']
        absences_accesses: ['absences_self_edit','telework_self_edit']
        # absences_routes: ['users_absences','users_telework','users_oncall_duties']
        absences_routes: ['users_absences','users_telework']

    methods:
        has_access_right: t.has_access_right
        absences_title: t.absences_title

        define_route: ()->
            for index, a of @absences_accesses
                if @has_access_right(a)
                    @$router.push({name:@absences_routes[index]})
                    .catch (err)-> {}
                    break
        
    beforeMount: ()->
        @head_title = @absences_title(@absences_accesses)
        @define_route()
}

